/* eslint-disable @stylistic/comma-dangle */

import { sharedLocale }	from "@geotoura/shared/sharedLocale_de";
import { numberFormat }	from "@geotoura/shared/numberFormat_de";
import * as fbModel		from "@geotoura/shared/fbModel";

import { Messages }		from "@geotoura/fb/locale";

export const messages:Messages = {
	format:	{
		number:	numberFormat,
	},
	nav: {
		start:		"Reiseplanung starten",
		back:		"Zurück",
		continue:	"Weiter",
		skip:		"Überspringen",
		send:		"Abschicken",
		finish:		"Zurück zur Startseite",
	},
	closeButton: {
		sr:	"Schließen"
	},
	text: {
		errorHeading:	"Fehler",
		errorText1:		"Beim Speichern Ihrer Daten ist leider ein Fehler aufgetreten.",
		errorText2:		"Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal oder kontaktieren Sie uns unter ",
		mailLink:		sharedLocale.email.info,
		errorText3:		" oder ",
		phoneLink:		sharedLocale.phone,
	},
	modal: {
		close:	"Schließen",
		submit:	"OK"
	},
	selectlist: {
		selectRegion:	"Region auswählen"
	},
	sliderLabel: (minLabel:string, maxLabel:string):string =>
		`Wählen Sie einen Wert auf einer Skala von ${fbModel.SliderValues.minimum} (${minLabel}) bis ${fbModel.SliderValues.maximum} (${maxLabel}) aus`,
	budget: {
		screenreaderHint: "Sie können einen von vier Beträgen mit den folgenden vier Buttons wählen oder mit einem Slider flexibel einstellen.",
		sliderLabel: (minLabel:string, maxLabel:string):string =>
			`Wählen Sie Ihr Reise-Gesamtbudget auf einer Skala von 0 für ${minLabel} bis 100 für ${maxLabel}`
	},
};
